import { generateRandomPastelColor } from './colorUtils.js';
import global from './global.js';
import { getVirusGif } from './app.js';
import config from './config.js';
import { getLogoUrl } from './utils.js';

// Add this near the top of the file, with other constant declarations
const saasLogoCache = new Map();

const cloudImages = [
    '../assets/images/1.png',
    '../assets/images/2.png',
    '../assets/images/3.png'
];

const foodImages = [
    '../assets/images/cloud1.png',
    '../assets/images/cloud2.png',
    '../assets/images/cloud3.png',
    '../assets/images/cloud4.png',
    '../assets/images/cloud5.png'
];

const loadedBackgroundImage = new Image();
const darkModeBackgroundImage = new Image();
const lightBackgroundImage = '../assets/images/background10.png';

loadedBackgroundImage.src = '../assets/images/background10.png';
darkModeBackgroundImage.src = '../assets/images/background9.png';

loadedBackgroundImage.onload = function() {
};

darkModeBackgroundImage.onload = function() {
};

loadedBackgroundImage.onerror = darkModeBackgroundImage.onerror = function() {
    console.error('Error loading background image');
};

const loadedCloudImages = cloudImages.map(src => {
    const img = new Image();
    img.src = src;
    img.onload = () => console.log(`Cloud image loaded: ${src}`);
    img.onerror = () => console.error(`Failed to load cloud image: ${src}`);
    return img;
});


const loadedFoodImages = foodImages.map(src => {
    const img = new Image();
    img.src = src;
    return img;
});

let foodImagesAssigned = false;
const foodImageMap = new Map();

const assignFoodImage = (x, y) => {
    const key = `${Math.round(x)},${Math.round(y)}`;
    if (!foodImageMap.has(key)) {
        const randomIndex = Math.floor(Math.random() * loadedFoodImages.length);
        foodImageMap.set(key, randomIndex);
    }
    return foodImageMap.get(key);
};

const getFoodImage = (x, y) => {
    const key = `${Math.round(x)},${Math.round(y)}`;
    if (!foodImageMap.has(key)) {
        assignFoodImage(x, y);
    }
    return loadedFoodImages[foodImageMap.get(key)];
};

const getFoodKey = (x, y) => `${Math.round(x)},${Math.round(y)}`;

const createClouds = (gameWidth, gameHeight, count) => {
    const clouds = [];
    for (let i = 0; i < count; i++) {
        const cloud = {
            x: Math.random() * gameWidth,
            y: Math.random() * gameHeight,
            size: Math.random() * 200 + 100, // Larger size range
            image: loadedCloudImages[Math.floor(Math.random() * loadedCloudImages.length)]
        };
        clouds.push(cloud);
    }
    return clouds;
};


const drawClouds = (graph, player, gameWidth, gameHeight, clouds) => {
    if (!Array.isArray(clouds)) {
        return;
    }
    
    clouds.forEach((cloud, index) => {
        const screenX = (cloud.x - player.x) * global.camera.zoom + graph.canvas.width / 2;
        const screenY = (cloud.y - player.y) * global.camera.zoom + graph.canvas.height / 2;
        
        const scaledSize = cloud.size * global.camera.zoom;
        
        if (screenX + scaledSize > 0 && screenX - scaledSize < graph.canvas.width &&
            screenY + scaledSize > 0 && screenY - scaledSize < graph.canvas.height) {
            
            if (!cloud.image) {
                console.error(`Cloud ${index} has no image`);
                return;
            }
            
            graph.globalAlpha = 0.7;
            graph.drawImage(cloud.image, screenX - scaledSize / 2, screenY - scaledSize / 2, scaledSize, scaledSize);
            graph.globalAlpha = 1;
        }
    });
};

const FULL_ANGLE = 2 * Math.PI;

const drawRoundObject = (position, radius, graph) => {
    graph.beginPath();
    graph.arc(position.x, position.y, radius, 0, FULL_ANGLE);
    graph.closePath();
    graph.fill();
    graph.stroke();
}

const drawFood = (position, food, graph) => {
    const foodImage = loadedFoodImages[food.imageIndex];
    
    const size = food.radius * 2;
    graph.drawImage(foodImage, position.x - food.radius, position.y - food.radius, size, size);
};


const getPosition = (item, player, gameSize) => {
    const x = item.x - player.x + gameSize.width / 2;
    const y = item.y - player.y + gameSize.height / 2;
    return { x, y };
};

// const drawVirus = (position, virus, graph) => {
    
//     if (global.getVirusGif && global.getVirusGif.complete) {
//         const size = virus.radius * 2;
//         graph.drawImage(global.getVirusGif, position.x - virus.radius, position.y - virus.radius, size, size);
//     } else {
//         // Fallback to original drawing if GIF is not loaded
//         graph.strokeStyle = virus.stroke;
//         graph.fillStyle = virus.fill;
//         graph.lineWidth = virus.strokeWidth;
//         drawRoundObject(position, virus.radius, graph);
//     }
// };

const drawVirus = (position, virus, graph) => {
    
    if (global.virusGif && global.virusGif.complete) {
        const size = virus.radius * 2;
        graph.drawImage(global.virusGif, position.x - virus.radius, position.y - virus.radius, size, size);
    } else {
        // Fallback to original drawing if GIF is not loaded
        graph.strokeStyle = virus.stroke;
        graph.fillStyle = virus.fill;
        graph.lineWidth = virus.strokeWidth;
        drawRoundObject(position, virus.radius, graph);
    }
};


const drawFireFood = (position, mass, playerConfig, graph) => {
    graph.strokeStyle = 'hsl(' + mass.hue + ', 100%, 45%)';
    graph.fillStyle = 'hsl(' + mass.hue + ', 100%, 50%)';
    graph.lineWidth = playerConfig.border + 2;
    drawRoundObject(position, mass.radius - 1, graph);
};

const valueInRange = (min, max, value) => Math.min(max, Math.max(min, value))


export function renderGame(gameState, player, ctx) {
    if (!ctx) {
        console.error('Canvas context is not available');
        return;
    }

    // Calculate the desired zoom level based on player size
    const desiredZoom = Math.max(0.5, 20 / player.radius);
    
    // Smoothly interpolate the zoom
    global.camera.zoom += (desiredZoom - global.camera.zoom) * 0.005;

    // Update camera position
    global.camera.x = player.x;
    global.camera.y = player.y;

    // Clear the canvas
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    // Draw the grid (background)
    drawGrid(global, player, global.screen, ctx);

    // Translate to the center of the screen
    ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2);

    // Scale the context (zoom)
    ctx.scale(global.camera.zoom, global.camera.zoom);

    // Translate to keep the player centered
    ctx.translate(-global.camera.x, -global.camera.y);

    // Draw clouds
    if (global.clouds && global.clouds.length > 0) {
        drawClouds(ctx, player, config.gameWidth, config.gameHeight, global.clouds);
    } else {
        console.warn('No clouds to draw. global.clouds:', global.clouds);
    }
    
    // Render game objects
    gameState.food.forEach(food => drawFoodCloud(food, food, ctx));
    gameState.viruses.forEach(virus => drawVirus(virus, virus, ctx));
    gameState.saasBlobs.forEach((saasBlob, index) => {
        drawSaasBlob(saasBlob, saasBlob, ctx);
    });
    if (player.cells && Array.isArray(player.cells)) {
        player.cells.forEach(cell => drawPlayerCloud(cell, player, ctx));
    }
    gameState.powerups.forEach(powerup => drawPowerup(powerup, powerup, ctx));

    // Reset the transformation
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    // Draw UI elements that should not be affected by zoom
    global.canvas.drawTouchController(ctx);
}

// const valueInRange = (min, max, value) => Math.min(max, Math.max(min, value))

const circlePoint = (origo, radius, theta) => ({
    x: origo.x + radius * Math.cos(theta),
    y: origo.y + radius * Math.sin(theta)
});

const cellTouchingBorders = (cell, borders) =>
    cell.x - cell.radius <= borders.left ||
    cell.x + cell.radius >= borders.right ||
    cell.y - cell.radius <= borders.top ||
    cell.y + cell.radius >= borders.bottom


const regulatePoint = (point, borders) => ({
    x: valueInRange(borders.left, borders.right, point.x),
    y: valueInRange(borders.top, borders.bottom, point.y)
});

const drawCellWithLines = (cell, borders, graph) => {
    let pointCount = 30 + ~~(cell.mass / 5);
    let points = [];
    for (let theta = 0; theta < FULL_ANGLE; theta += FULL_ANGLE / pointCount) {
        let point = circlePoint(cell, cell.radius, theta);
        points.push(regulatePoint(point, borders));
    }
    graph.beginPath();
    graph.moveTo(points[0].x, points[0].y);
    for (let i = 1; i < points.length; i++) {
        graph.lineTo(points[i].x, points[i].y);
    }
    graph.closePath();
    graph.fill();
    graph.stroke();
}


function drawFoodCloud(position, food, ctx) {
    const cloudImage = getFoodImage(food.x, food.y);
    const size = food.radius * 10;
    ctx.drawImage(cloudImage, position.x - size / 2, position.y - size / 2, size, size);
}

const drawCells = (cells, playerConfig, toggleMassState, borders, graph) => {
    for (let cell of cells) {
        // Draw the cell itself
        graph.fillStyle = cell.color;
        graph.strokeStyle = cell.borderColor;
        graph.lineWidth = 6;
        if (cellTouchingBorders(cell, borders)) {
            // Asssemble the cell from lines
            drawCellWithLines(cell, borders, graph);
        } else {
            // Border corrections are not needed, the cell can be drawn as a circle
            drawRoundObject(cell, cell.radius, graph);
        }

        // Draw the name of the player
        let fontSize = Math.max(cell.radius / 3, 12);
        graph.lineWidth = playerConfig.textBorderSize;
        graph.fillStyle = playerConfig.textColor;
        graph.strokeStyle = playerConfig.textBorder;
        graph.miterLimit = 1;
        graph.lineJoin = 'round';
        graph.textAlign = 'center';
        graph.textBaseline = 'middle';
        graph.font = 'bold ' + fontSize + 'px sans-serif';
        graph.strokeText(cell.name, cell.x, cell.y);
        graph.fillText(cell.name, cell.x, cell.y);

        // Draw the mass (if enabled)
        if (toggleMassState === 1) {
            graph.font = 'bold ' + Math.max(fontSize / 3 * 2, 10) + 'px sans-serif';
            if (cell.name.length === 0) fontSize = 0;
            graph.strokeText(Math.round(cell.mass), cell.x, cell.y + fontSize);
            graph.fillText(Math.round(cell.mass), cell.x, cell.y + fontSize);
        }
    }
};


const drawGrid = (global, player, screen, graph) => {
    const isDarkMode = document.body.classList.contains('dark-mode');
    const backgroundImage = isDarkMode ? darkModeBackgroundImage : loadedBackgroundImage;
    
    if (backgroundImage.complete && backgroundImage.naturalWidth !== 0) {
        const canvasWidth = graph.canvas.width;
        const canvasHeight = graph.canvas.height;
        
        // Calculate the scale to cover the entire canvas
        const scaleX = canvasWidth / backgroundImage.width;
        const scaleY = canvasHeight / backgroundImage.height;
        const scale = Math.max(scaleX, scaleY);
        
        const scaledWidth = backgroundImage.width * scale;
        const scaledHeight = backgroundImage.height * scale;
        
        // Calculate offsets to center the image
        const offsetX = (canvasWidth - scaledWidth) / 2;
        const offsetY = (canvasHeight - scaledHeight) / 2;
        
        // Save the current context state
        graph.save();
        
        // Translate the context to adjust for player position
        graph.translate(-player.x * global.camera.zoom + canvasWidth / 2, -player.y * global.camera.zoom + canvasHeight / 2);
        
        // Scale the context to match the camera zoom
        graph.scale(global.camera.zoom, global.camera.zoom);
        
        // Draw the background image
        graph.drawImage(backgroundImage, 
            (player.x - canvasWidth / (2 * global.camera.zoom) + offsetX / global.camera.zoom), 
            (player.y - canvasHeight / (2 * global.camera.zoom) + offsetY / global.camera.zoom), 
            scaledWidth / global.camera.zoom, 
            scaledHeight / global.camera.zoom);
        
        // Restore the context state
        graph.restore();
    } else {
        // Fallback to solid color if image is not loaded
        graph.fillStyle = isDarkMode ? '#1a1a1a' : '#D1E2F1';
        graph.fillRect(0, 0, graph.canvas.width, graph.canvas.height);
    }
}



// const drawGrid = (global, player, screen, graph) => {
//     // Background is now handled by CSS
// };

const drawBorder = (borders, graph) => {
    graph.lineWidth = 1;
    graph.strokeStyle = '#000000'
    graph.beginPath()
    graph.moveTo(borders.left, borders.top);
    graph.lineTo(borders.right, borders.top);
    graph.lineTo(borders.right, borders.bottom);
    graph.lineTo(borders.left, borders.bottom);
    graph.closePath()
    graph.stroke();
    graph.globalAlpha = 1;
};


const drawErrorMessage = (message, graph, screen) => {
    graph.fillStyle = '#333333';
    graph.fillRect(0, 0, screen.width, screen.height);
    graph.textAlign = 'center';
    graph.fillStyle = '#FFFFFF';
    graph.font = 'bold 30px sans-serif';
    graph.fillText(message, screen.width / 2, screen.height / 2);
}

const drawSaasBlob = (saasBlob, _, graph) => {
    const position = { x: saasBlob.x, y: saasBlob.y };
    const saasName = saasBlob.saasInfo && saasBlob.saasInfo.saasname;
    const fallbackText = saasName || 'Unknown SaaS';
    const logoSize = saasBlob.radius * 2;

    if (saasName) {
        let logoImage = saasLogoCache.get(saasName);
        
        if (!logoImage) {
            const [pngPath, svgPath] = getLogoUrl(saasName);
            logoImage = new Image();
            logoImage.src = svgPath;
            logoImage.onerror = () => {
                logoImage.src = pngPath;
            };
            saasLogoCache.set(saasName, logoImage);
            
            logoImage.onload = () => {
                if (typeof global.requestAnimationFrame === 'function') {
                    global.requestAnimationFrame(() => drawSaasBlob(saasBlob, saasBlob, graph));
                }
            };
        }

        if (logoImage.complete && logoImage.naturalWidth !== 0) {
            graph.drawImage(
                logoImage,
                position.x - logoSize / 2,
                position.y - logoSize / 2,
                logoSize,
                logoSize
            );
        } else {
            drawFallbackText();
        }
    } else {
        drawFallbackText();
    }

    function drawFallbackText() {
        graph.fillStyle = 'white';
        graph.font = `${saasBlob.radius * 0.3}px Arial`;
        graph.textAlign = 'center';
        graph.textBaseline = 'middle';
        graph.fillText(fallbackText, position.x, position.y);
    }
}

// Add this function to clean up unused food image assignments
const cleanupFoodImageMap = (currentFoodPositions) => {
    const currentKeys = new Set(currentFoodPositions.map(pos => `${Math.round(pos.x)},${Math.round(pos.y)}`));
    for (const key of foodImageMap.keys()) {
        if (!currentKeys.has(key)) {
            foodImageMap.delete(key);
        }
    }
};


const drawCloud = (cell, graph) => {
    const cloudWidth = cell.radius * 2;
    const cloudHeight = cloudWidth * (120 / 350);
  
    graph.save();
    graph.translate(cell.x - cloudWidth / 2, cell.y - cloudHeight / 2);
  
    // Use the cell's cloudColor or a default color if it's undefined
    const cloudColor = cell.cloudColor || generateRandomPastelColor();
    const borderColor = adjustColor(cloudColor, -20);
  
    // Function to draw the cloud shape
    const drawCloudShape = () => {
        // Main cloud body
        graph.beginPath();
        graph.moveTo(0, cloudHeight / 2);
        graph.arcTo(0, 0, cloudWidth, 0, cloudHeight / 2);
        graph.arcTo(cloudWidth, 0, cloudWidth, cloudHeight, cloudHeight / 2);
        graph.arcTo(cloudWidth, cloudHeight, 0, cloudHeight, cloudHeight / 2);
        graph.arcTo(0, cloudHeight, 0, 0, cloudHeight / 2);
        
        // Before pseudo-element (larger circle) - moved more to the left
        graph.moveTo(cloudWidth * 0.3, cloudHeight * 0.3);
        graph.arc(cloudWidth * 0.6, cloudHeight * 0.1, cloudWidth * (180 / 350) / 2, 0, Math.PI * 2);
        
        // After pseudo-element (smaller circle)
        graph.moveTo(cloudWidth * 0.3, cloudHeight * 0.1);
        graph.arc(cloudWidth * 0.3, cloudHeight * 0.1, cloudWidth * (100 / 350) / 2, 0, Math.PI * 2);
        
        graph.closePath();
    };

    // Draw the cloud outline with a thicker border
    graph.lineWidth = 10;
    graph.strokeStyle = borderColor;
    drawCloudShape();
    graph.stroke();

    // Fill the cloud
    graph.fillStyle = cloudColor;
    drawCloudShape();
    graph.fill();
  
    // Add shadow
    graph.shadowColor = 'rgba(0, 0, 0, 0.2)';
    graph.shadowBlur = 10;
    graph.shadowOffsetX = 5;
    graph.shadowOffsetY = 5;
    graph.fill();
  
    // Reset shadow
    graph.shadowColor = 'transparent';
    graph.shadowBlur = 0;
    graph.shadowOffsetX = 0;
    graph.shadowOffsetY = 0;
  
    graph.restore();
};

// Helper function to adjust color lightness
function adjustColor(color, amount) {
    try {
        const hsl = color.match(/\d+/g).map(Number);
        if (hsl && hsl.length === 3) {
            hsl[2] = Math.max(0, Math.min(100, hsl[2] + amount));
            return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
        }
    } catch (error) {
        console.error('Error adjusting color:', error);
    }
    return color; // Return the original color if there's an error
}

// function assignFoodImages() {
//     // Implement this function or import it from another module
// }

// function generateRandomPastelColor() {
//     // Implement this function or import it from another module
// }


function drawPlayerCloud(position, player, ctx) {
    // Set up the cell object with necessary properties
    const cloudCell = {
        x: position.x,
        y: position.y,
        radius: player.radius,
        cloudColor: player.cloudColor || generateRandomPastelColor()
    };

    // Call the drawCloud function
    drawCloud(cloudCell, ctx);
    
    // Draw player name inside the cloud
    ctx.save();
    ctx.fillStyle = 'white';
    ctx.font = `bold ${Math.max(player.radius / 3, 12)}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // Remove shadow or make it very light
    ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';  // Very light shadow
    ctx.shadowBlur = 2;  // Minimal blur
    ctx.shadowOffsetX = 1;
    ctx.shadowOffsetY = 1;

    ctx.fillText(player.name || '', position.x, position.y);
    ctx.restore();
}

// Add this function to your render.js file
const drawPowerup = (position, powerup, ctx) => {
    const centerX = position.x;
    const centerY = position.y;
    const radius = powerup.radius;

    // Create animated rotation
    const time = Date.now() * 0.001; // Current time in seconds
    const rotationSpeed = 3; // Adjust for faster/slower rotation

    ctx.save();
    ctx.translate(centerX, centerY);
    ctx.rotate(time * rotationSpeed);
    ctx.translate(-centerX, -centerY);

    // Draw the tornado
    const height = radius * 2;
    const baseWidth = radius * 1.5;
    const topWidth = radius * 0.2;

    // Create a gradient for the tornado
    const gradient = ctx.createLinearGradient(centerX - baseWidth / 2, centerY + height / 2, centerX + baseWidth / 2, centerY - height / 2);
    gradient.addColorStop(0, 'rgba(0, 191, 255, 0.8)');  // Deep Sky Blue
    gradient.addColorStop(0.5, 'rgba(135, 206, 250, 0.7)'); // Light Sky Blue
    gradient.addColorStop(1, 'rgba(240, 248, 255, 0.6)');   // Alice Blue

    ctx.fillStyle = gradient;

    // Draw the funnel shape
    ctx.beginPath();
    ctx.moveTo(centerX - baseWidth / 2, centerY + height / 2);
    ctx.quadraticCurveTo(centerX, centerY, centerX + topWidth / 2, centerY - height / 2);
    ctx.lineTo(centerX - topWidth / 2, centerY - height / 2);
    ctx.quadraticCurveTo(centerX, centerY, centerX - baseWidth / 2, centerY + height / 2);
    ctx.closePath();
    ctx.fill();

    // Draw swirling lines
    const swirls = 3;
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
    ctx.lineWidth = 3;

    for (let i = 0; i < swirls; i++) {
        ctx.beginPath();
        for (let j = 0; j <= 100; j++) {
            const t = j / 100;
            const angle = (3 * Math.PI * t) + (i * Math.PI * 2 / swirls) + time * rotationSpeed;
            const scale = 1 - t * 0.8; // Tornado gets thinner at the top
            const width = baseWidth * (1 - t) + topWidth * t;
            const x = centerX + Math.cos(angle) * width * 0.5 * scale;
            const y = centerY + height * (0.5 - t);
            ctx.lineTo(x, y);
        }
        ctx.stroke();
    }

    // Add a glowing effect
    ctx.globalCompositeOperation = 'lighter';
    const glowGradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius * 1.2);
    glowGradient.addColorStop(0, 'rgba(255, 255, 255, 0.4)');
    glowGradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
    ctx.fillStyle = glowGradient;
    ctx.fillRect(centerX - radius * 1.2, centerY - radius * 1.2, radius * 2.4, radius * 2.4);
    ctx.globalCompositeOperation = 'source-over';

    ctx.restore();
};

// Make sure to export the function if you're using ES6 modules
export { drawPowerup };

export {
    drawFood,
    drawVirus,
    drawFireFood,
    drawCells,
    drawErrorMessage,
    drawGrid,
    drawBorder,
    drawSaasBlob,
    drawPlayerCloud,
    drawClouds,
    createClouds,
    cleanupFoodImageMap,
    drawCloud
};






